import DOMPurify from 'isomorphic-dompurify'

function isElement(node: Node): node is Element {
  return node.nodeType === node.ELEMENT_NODE
}

DOMPurify.addHook('beforeSanitizeElements', (node) => {
  if (!isElement(node)) {
    return
  }

  if (node.tagName === 'A' && node.getAttribute('href')?.startsWith('https://wp.toxicsushi.de/wp-content/uploads/')) {
    const parent = node.parentNode
    while (node.firstChild) {
      parent?.insertBefore(node.firstChild, node)
    }
    parent?.removeChild(node)
  }
})

DOMPurify.addHook('uponSanitizeElement', (node, data) => {
  if (!isElement(node)) {
    return
  }

  if (data.tagName === 'p') {
    node.classList.add('mb-4')
  }
  if (data.tagName === 'h3') {
    node.classList.add('font-bold', 'text-white')
  }
  if (data.tagName === 'a') {
    node.classList.add('text-white', 'hover:underline')
  }
  if (data.tagName === 'iframe') {
    node.classList.add('mb-4')
  }
})

export function sanitize(htmlContent: string) {
  return DOMPurify.sanitize(htmlContent, {
    ALLOWED_TAGS: ['p', 'iframe', 'img', 'a', 'h1', 'h2', 'h3', 'br'],
  })
}
